exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading__spinner___3IG5f{position:absolute;top:100px;left:0;width:100%;text-align:center}.loading__inline___2TlAC{position:relative}.loading__spinnerItem___1j_L6{width:28px;height:28px;background-color:#00aeef;border-radius:100%;display:inline-block;animation:loading__sk-bouncedelay___G7waj 1.4s infinite ease-in-out both}.loading__spinner1___3qD0L{animation-delay:-.32s}.loading__spinner2___3MmMx{animation-delay:-.16s}@keyframes loading__sk-bouncedelay___G7waj{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}", ""]);

// exports
exports.locals = {
	"spinner": "loading__spinner___3IG5f",
	"inline": "loading__inline___2TlAC",
	"spinnerItem": "loading__spinnerItem___1j_L6",
	"sk-bouncedelay": "loading__sk-bouncedelay___G7waj",
	"spinner1": "loading__spinner1___3qD0L",
	"spinner2": "loading__spinner2___3MmMx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/loading.scss
// module id = 1069
// module chunks = 0